function showSearch() {
	var s = $("#search");
	if ( s.hasClass("invisible") ) {
		s.removeClass("invisible");
		s.addClass("visible");	
	} else {
		s.removeClass("visible");
		s.addClass("invisible");	
	}
	
	
}

$(document).ready(function() {

	// Scroll to the top for mobile phones on load
	window.scrollTo(0,1);

	// Testing touch events in modernizr
	//if ( $(".touch").length ) {
	//	alert("Touch!");
	//}

	// Show search input when clicking the Search button in top nav
	$(".top_bar a[href*='#search']").click(function(e) {
		e.preventDefault();
		showSearch();
	});

});